import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { TextField } from '@mui/material';
import Stack from '@mui/material/Stack';
import { useCreateModule } from '../../../hooks/useCreateModule';
import { useUpdateModule } from '../../../hooks/useUpdateModule';
import { useSnackbar } from '../../../context/SnackbarContext';
import { useTranslation } from 'react-i18next';

export default function ModuleForm({ successCallback = null, module = null, mode = "create", open, onClose }) {

    const { t } = useTranslation('common'); 

    const [name, setName] = React.useState(module ? module.name : "");
    const [sequence, setSequence] = React.useState(module ? module.sequence : "");

    const { create } = useCreateModule(successCallback);
    const { update } = useUpdateModule(successCallback);

    const { showSnackbar } = useSnackbar();

    React.useEffect(() => {
        // reset field when company changes (e.g. when opening edit)
        setName(module ? module.name : "");
        setSequence(module ? module.sequence : "");
    }, [module, open]);

    const handleSave = async () => {
        if (!name.trim()) {
            showSnackbar(t('app_modules.messages.name_required'), "warning");
            return;
        }
        if (!sequence) {
            showSnackbar(t('app_modules.messages.sequence_required'), "warning");
            return;
        }

        try 
        {
            if (mode === "create") {
                await create({ name, sequence });
                showSnackbar(t('app_modules.messages.create_success'), "success");
            } else if (mode === "edit" && module) {
                await update(module.id, { name, sequence });
                showSnackbar(t('app_modules.messages.update_success'), "success");
            }
            setName("");
            setSequence("");
            onClose();     // close dialog
        } catch (err) {
            showSnackbar(t('app_modules.messages.save_fail'), "error");
        }

    };

    const handleCancel = () => {
        setName("");
        onClose();
    };

    return (
        <Dialog onClose={handleCancel} open={open} disableRestoreFocus>
        <DialogTitle>{mode === "create" ? "Add Module" : "Edit Module"}</DialogTitle>

        <DialogContent dividers>
            <Stack spacing={1}>
            <TextField
                label="Module Name"
                variant="outlined"
                value={name}
                onChange={(e) => setName(e.target.value)}
                fullWidth
            />
            <TextField
                label="Sequence Number"
                variant="outlined"
                value={sequence}
                onChange={(e) => setSequence(e.target.value)}
                fullWidth
                type='number'
            />
            </Stack>
        </DialogContent>

        <DialogActions>
            <Button onClick={handleSave}>Save</Button>
            <Button onClick={handleCancel}>Cancel</Button>
        </DialogActions>
        </Dialog>
    );
}